import { render, staticRenderFns } from "./RetrievelRejectReason.vue?vue&type=template&id=2b8e94ad"
import script from "./RetrievelRejectReason.vue?vue&type=script&lang=js"
export * from "./RetrievelRejectReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports